<template>
  <back-office-list
    :title="this.$t('common.bridges')"
    :has-add-button="true"
    :add-button-caption="this.$t('bridges.add')"
    :loading="bridgesMeta.loading"
    :list-data="bridges"
    route-to-add-page="add-bridge"
    :selection-change="handleSelectionChange"
  />
</template>

<script>
  import { bridgeService } from '@/services'
  import BackOfficeList from '@/components/BackOfficeList'
  import { useQuery } from 'codefabrik-gui-vue/src/apollo'

  export default {
    name: 'Bridges',
    components: { BackOfficeList },
    mixins: [
      useQuery({
        name: 'bridges',
        serviceFn: bridgeService.getBridges,
        mappingFunctions: {
          bridges: [(bridgePage) => bridgePage.bridge, () => []]
        }
      })
    ],
    methods: {
      handleSelectionChange (bridge) {
        this.$router.push({ name: 'edit-bridge', params: { id: bridge.id } })
      }
    },
  }
</script>

<style
  lang="scss"
  scoped
>
</style>
